import { AnimatePresence, m } from "motion/react";
import type { FC } from "react";
import type { ReviewType } from "../../../../../modules/reviews-module";
import LazyFramer from "../../../LazyFramer";
import Review from "../Review/Review";
import * as s from "./ReviewSlider.module.scss";

type ReviewSliderProps = {
	activeReview: ReviewType;
	dir: number;
};

const ReviewSlider: FC<ReviewSliderProps> = ({ activeReview, dir }) => {
	const { _uid, rating, title, quote, name } = activeReview;

	if (_uid === null || rating === null || quote === null || name === null) {
		return null;
	}

	return (
		<LazyFramer>
			<AnimatePresence mode="wait" custom={dir}>
				<m.div
					key={_uid}
					variants={variants}
					initial="enter"
					animate="center"
					exit="exit"
					custom={dir}
					transition={{ duration: 0.2 }}
					className={s.reviewSlider}
				>
					<Review
						rating={rating}
						title={title || ""}
						quote={quote}
						name={name}
					/>
				</m.div>
			</AnimatePresence>
		</LazyFramer>
	);
};

const variants = {
	enter: (dir: number) => ({ x: dir * 10, opacity: 0 }),
	center: { x: 0, opacity: 1 },
	exit: (dir: number) => ({ x: dir * -10, opacity: 0 }),
};

export default ReviewSlider;
